import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import { createSavedSearchesApiService } from "../../sub-modules/saved-search/services/api/apiService";
import type { LeadsColumnsConfigDto, LeadsSelectedColumnsRequestDto } from "../../types";

import { createCompaniesApiService } from "./companiesApiService";
import { BASE_ENDPOINT_PATH } from "./const";
import { createWebsitesApiService } from "./websitesApiService";

const createLeadsSearchApiService = (fetchService: IFetchService) => {
    return {
        companies: createCompaniesApiService(fetchService),
        websites: createWebsitesApiService(fetchService),
        savedSearches: createSavedSearchesApiService(fetchService),

        fetchColumnConfig(options?: Readonly<GetRequestOptions>): Promise<LeadsColumnsConfigDto> {
            return fetchService.get(`${BASE_ENDPOINT_PATH}/description/columns`, undefined, options);
        },

        saveColumnSelection(dto: Readonly<LeadsSelectedColumnsRequestDto>): Promise<void> {
            return fetchService.put(`${BASE_ENDPOINT_PATH}/description/columns/selection`, dto);
        },
    };
};

export default createLeadsSearchApiService;
